import {
  LayoutDashboard, Calendar, ClipboardList, Users, UserCircle, BarChart3, Settings,
  Building2, ShoppingBag, MessageSquare, Megaphone, Inbox, Receipt,
} from "lucide-react";
import { safeGetItem } from "./safeStorage";

export const ALL_ROLES = ["owner", "admin", "reception", "staff"];

/* Navigation – gruppiert, plan-gated, Beschriftungen kommen aus dem Betriebsart-Vokabular.
   Gruppen mit eigenem `href` sind gleichzeitig anklickbar: der Name navigiert, das
   Chevron klappt nur auf. Ohne das bräuchte der Kalender – der meistgeklickte Eintrag
   der App – plötzlich zwei Klicks. */
export const buildNavigation = (vocab) => [
  { name: "Dashboard", href: "/dashboard", icon: LayoutDashboard, roles: ALL_ROLES, permission: "dashboard_access" },
  {
    name: "Kalender",
    href: "/calendar",
    icon: Calendar,
    roles: ALL_ROLES,
    children: [
      { name: "Arbeitszeiten", href: "/work-schedule", roles: ALL_ROLES },
      /* Ohne Feature-Gate: die Waitlist-Seite betrachtet sich als aktiv, solange das
         Flag nicht explizit false ist, und zeigt ihre Sperre selbst an. */
      { name: "Warteliste", href: "/waitlist", roles: ALL_ROLES },
    ],
  },
  { name: "Messenger", href: "/messenger", icon: MessageSquare, roles: ALL_ROLES, feature: "messenger", permission: "messenger_access" },
  { name: "Anfragen", href: "/anfragen", icon: Inbox, roles: ALL_ROLES, feature: "patient_acquisition", permission: "patient_acquisition:read" },
  {
    name: vocab.person.pl,
    href: "/clients",
    icon: UserCircle,
    roles: ALL_ROLES,
    permission: "clients:read",
    children: [
      { name: `Alle ${vocab.person.pl}`, href: "/clients", roles: ALL_ROLES, permission: "clients:read" },
      { name: "Formulare", href: "/forms", roles: ALL_ROLES, permission: "forms:read" },
    ],
  },
  { name: vocab.service.pl, href: "/services", icon: ClipboardList, roles: ALL_ROLES, permission: "services:manage" },
  {
    name: "Rechnungen", href: "/invoices", icon: Receipt,
    roles: ALL_ROLES, permission: "reports_access",
  },
  { name: vocab.staff.pl, href: "/staff", icon: Users, roles: ["owner", "admin"] },
  {
    name: "Marketing",
    icon: Megaphone,
    roles: ["owner", "admin"],
    children: [
      { name: "Automationen", href: "/marketing/automations", feature: "instagram_automation" },
      { name: "Newsletter", href: "/marketing/newsletter", feature: "email_marketing", permission: "newsletter_access" },
      { name: "Gesendete Newsletter", href: "/marketing/newsletter/versendet", feature: "email_marketing", permission: "newsletter_access" },
      { name: "Gutscheine", href: "/vouchers", feature: "vouchers" },
      { name: "Content Bibliothek", href: "/content-bibliothek", feature: "ad_manager" },
    ],
  },
  { name: "Shop", href: "/shop", icon: ShoppingBag, roles: ["owner", "admin"], feature: "shop" },
  { name: "Berichte", href: "/reports", icon: BarChart3, roles: ALL_ROLES, feature: "reports_basic", permission: "reports_access" },
  { name: "Standorte", href: "/locations", icon: Building2, roles: ALL_ROLES, permission: "locations:manage" },
  { name: "Einstellungen", href: "/settings", icon: Settings, roles: ["owner", "admin"] },
];

/* Routen, die kein Menüeintrag mehr abdeckt, aber trotzdem erreichbar bleiben müssen.
   Der Route-Guard im DashboardLayout leitet sonst auf /dashboard um. */
export const HIDDEN_PERMISSION_ROUTES = [{ href: "/materials", permission: "calendar:write", roles: ALL_ROLES }];

export const EXTRA_ALLOWED_PATHS = ["/upgrade", "/policies", "/setup"];

export const NAV_TOUR_IDS = {
  "/settings": "setup-nav-settings",
  "/locations": "setup-nav-locations",
  "/services": "setup-nav-services",
  "/dashboard": "setup-nav-dashboard",
};

export const EXPANDED_GROUPS_STORAGE_KEY = "mib_sidebar_groups_v1";

export function readExpandedGroups() {
  try {
    const parsed = JSON.parse(safeGetItem(EXPANDED_GROUPS_STORAGE_KEY) || "{}");
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}
